import { LineItem, Locale, Totals } from 'app/state/types'
import { OrderItem, ShoppingCart } from './common-types'

export enum SaleOrderFlag {
    FullPriceOrder = 'full price order',
    SaleOrder = 'sale order',
    PromoOrder = 'promo order',
    PartialSaleOrPromoOrder = 'partial sale or promo order',
}

export enum TaxAndDutyFlag {
    TaxAndDutyIncluded = 'tax and duty included',
    TaxAndDutyAdded = 'tax and duty added',
    SalesTaxAdded = 'sales tax added',
    NotAvailable = 'not available',
    NoAdditionalTax = 'no additional tax',
}

export type CheckoutAnalytics = Pick<OrderItem, 'genericTotal'> & {
    lineItems: LineItem[]
    totals?: Totals
    orderId: number
    basePrice?: number | null
    basePriceGBP?: number | null
    itemSubtotal?: number
    transactionTotal?: number
    saleOrderFlag: SaleOrderFlag
    taxAndDuty: number
    localCustomsFee: number
    storeCredit: number
    taxAndDutyFlag: TaxAndDutyFlag
    analytics: {
        business?: 'NAP' | 'MRP'
    }
    locale: Locale
    x_exchangeRate: ShoppingCart['x_exchangeRate']
    userStatus: ShoppingCart['x_userStatus']
    useIdentifier: boolean
}
